

import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {ILocker2} from "@/model/Locker/lockerInterfaces";
import {IOnOffHandlers} from "bonomo";
import {ILockerCompany} from "@/model/LockerCompany/lockerCompanyInterface";
import {namespace} from "vuex-class";
import {EPermissionActions} from "@/model/EPermissionActions";
import SimpleConfirmationDialog from "@/components/shared/SimpleConfirmationDialog.vue";

const lockerCompanyModule = namespace("lockerCompanyModule");
const locker2Module = namespace("locker2Module");

@Component({
  components: {SimpleConfirmationDialog}
})
export default class LLandingVersion extends Vue {

  @locker2Module.Action('setLandingVersion')
  setLandingVersion!: (data: { lockerId: number, landing: number }) => void;

  @lockerCompanyModule.Getter('lockerCompanies')
  lockerCompanies!: ILockerCompany[]

  @Prop()
  locker!: ILocker2;
  @Prop()
  disabled!: boolean;
  @Prop()
  editing!: boolean;

  loading: boolean = false;
  submitting: boolean = false;
  subscribes: IOnOffHandlers = {};
  landing: string = '0';

  get canEdit(): boolean {
    return this.$canAction(EPermissionActions.ACTION_LOCKERS_UPDATE);
  }

  get items(): any[] {
    const items = this.$t('lockers.locker.fields.landing_version.values');
    const ret = Object.keys(items)
        .map((key) => ({
          text: this.$t('lockers.locker.fields.landing_version.values.' + key),
          value: key
        }));
    ret.unshift({text: '-', value: '0'});
    return ret;
  }

  created() {
    this.subscribes = this.$ons({
      'backend.call.OK.locker2Loaded': this.onLockerLoaded,
      'backend.call.OK.lockerLandingVersionSet': this.onOK,
      'backend.call.KO.lockerLandingVersionSet': this.onKO,
    });
    if (this.locker) {
      this.onLockerLoaded();
    }
  }

  beforeDestroy() {
    this.$offs(this.subscribes);
  }

  onCancel() {
    this.onLockerLoaded();
    this.stopEditing();
  }

  onEdit() {
    this.$emit('update:editing', true);
  }

  onKO() {
    this.submitting = false;
  }

  onLockerLoaded() {
    this.landing = '' + this.locker.landing_version;
  }

  onOK() {
    this.stopEditing();
    this.submitting = false;
  }

  onSave() {
    if (this.landing != '' + this.locker.landing_version) {
      this.setLandingVersion({ lockerId: this.locker.id, landing: Number.parseInt(this.landing) });
    }
    else {
      this.stopEditing();
    }
  }

  stopEditing() {
    this.$emit('update:editing', false);
  }

}

